import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";
import { IGetAllControlePatrimonioUseCase } from "../../../presentation/useCases/read/get_all_controle_patrimonio_use_case";
import { ControlePatrimonioLista } from "../../models/controle_patrimonio_lista";

/**
 * GetAllControlePatrimonioUseCase
 */

export class GetAllControlePatrimonioUseCase
  extends BasePaginatedUseCase<ControlePatrimonioLista>
  implements IGetAllControlePatrimonioUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {
    super();
  }

  async getAllControlePatrimonio(
    codigo: string | null,
    descricao: string | null,
    status: number | null,
    localizacao: string | null,
    centroCusto: number[] | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllControlePatrimonio(
      codigo,
      descricao,
      status,
      localizacao,
      centroCusto,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
